import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SelectorFieldComponent} from './selector-field.component';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatSelectModule} from '@angular/material/select'
import {ReactiveFormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';


@NgModule({
  declarations: [
    SelectorFieldComponent
  ],
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatSelectModule,
    ReactiveFormsModule,
    TranslateModule
  ],
  exports: [
    SelectorFieldComponent
  ]
})
export class SelectorFieldModule { }
